export default __webpack_public_path__ + "static/media/6.4d301d7e.svg";